// Early sign-up and priority access are managed per event in the scheduler, not on the patroller.
// The old per-user priority fields are ignored by the server, so the generic user save must never send them.
export const stripPriorityFields = (user) => {
    const { priorityAccess, priorityAccessExpires, ...rest } = user; // eslint-disable-line no-unused-vars

    return rest;
};
